import { ErrorMessage, Form, Formik } from 'formik'
import { useState } from 'react'
import DatepickerContainer from '../../forms/fields/DatepickerContainer'
import Translation from '../../Translation/cont/Translation'
import * as Yup from 'yup';
import TranslationDate from '../../Translation/cont/TranslationDate';

const PrintWeekProgramFlyerDateItem = ({printToolUpdateDatePeriod, printToolDeleteDatePeriod, currentPeriodItem}) => {
    const [editDate, setEditDate] = useState(false)

    if(!currentPeriodItem) {
        return ''
    }

    const validationSchema = Yup.object().shape({
        startDate: Yup.string().required(<Translation id="formik_field_required" />),
        endDate: Yup.string().required(<Translation id="formik_field_required" />)
    });

    const {startDate, endDate, id} = currentPeriodItem

    return (
        <div className={"selections-item-wrapper custom-period-wrapper"}>
            {editDate ? (
                <div className="button-selection-wrapper odd gap-35">
                    <button disabled className="icon button-edit button-edit-selection button">
                        <span className="screen-reader-text">edit</span>
                    </button>
                </div>
            ) : (
                <div className="button-selection-wrapper odd gap-35">
                    <button type="button" className="icon button-edit button-edit-selection button"  onClick={() => setEditDate(true)}>
                        <span className="screen-reader-text">edit</span>
                    </button>
                </div>
            )}
            <div className="button-selection-wrapper even gap-35">
                <div className="icon button-move button-move-selection button">
                    <span className="screen-reader-text">Drag and Drop zum Bewegen der Elemente</span>
                </div>
            </div>
            <div className="button-selection-wrapper odd gap-35">
                <button type="button" className="button icon button-delete button-delete-selection" onClick={() => printToolDeleteDatePeriod(id)}>
                    <span className="screen-reader-text">Delete</span>
                </button>
            </div>
           {editDate ? (
             <div className={"selections-item edit-period-wrapper"}>
                <h3 className="selections-item-title site-content-wrapper-inner title-large-light button-selection-wrapper odd gap-10">
                    <Formik
                        initialValues={{
                            startDate:startDate,
                            endDate:endDate,
                            id: id
                        }}
                        validationSchema={validationSchema}
                        onSubmit={(values, actions) => {
                            printToolUpdateDatePeriod(values)
                            actions.resetForm()
                            setEditDate(false)
                        }}
                    >
                    {({values, errors, touched, isSubmitting, handleReset, setFieldValue}) => 
                        <Form>
                            <div className="datepicker-container">
                                <div className="datepicker-wrapper">
                                    <DatepickerContainer
                                        name={"startDate"} 
                                        onChange={setFieldValue}
                                        value={values.startDate}
                                        resetValue={'endDate'}
                                        isStartDate={true}
                                        type="text" 
                                        id="startDate" 
                                        end={values.endDate}
                                    />
                                    <ErrorMessage className="text-regular-color" name="startDate" component="div" />  
                                </div>
                                <div className="datepicker-wrapper">
                                    <DatepickerContainer
                                        name={"endDate"} 
                                        onChange={setFieldValue}
                                        value={values.endDate}
                                        start={values.startDate}
                                        type="text" 
                                        id="endDate"
                                    />
                                    <ErrorMessage className="text-regular-color" name="endDate" component="div" />  
                                </div>
                                <button type="submit" className='button button-text'><Translation id="save_button">Speichern</Translation></button>
                            </div>
                        </Form>}
                    </Formik>
                </h3>
            </div>
           ) : (
                <div className={"selections-item edit-period-wrapper"}>
                    {startDate && endDate && <h3 className="selections-item-title site-content-wrapper-inner title-large-light button-selection-wrapper odd gap-10">
                        <span className="title-large-light "><TranslationDate hasWeekday={true} string={startDate}/> - <TranslationDate hasWeekday={true} string={endDate}/></span>
                    </h3>}
                </div>
            )}
        </div>
    )
}

export default PrintWeekProgramFlyerDateItem